

import Component from "vue-class-component";
import Vue from "vue";
import {VModel} from "vue-property-decorator";

@Component({})
export default class ChannelSelector extends Vue {

  @VModel()
  protected channelId!: number;

  get channelItems(): any[] {
    const channels = this.$t('channels.names') as any;
    const ret: any[] = [];
    for (let i in Object.keys(channels)) {
      ret.push({text: channels[i], value: Number(i)})
    }
    return ret;
  }

}

